<template>
  <div>
    <div class="row mb-1">
      <div class="col-3" v-if="isSearch">
        <div class="job-filter">
          <div class="faq-form">
            <feather class="search-icon" type="search"></feather>
            <b-form-input type="text" placeholder="Search.." v-model="search" class="btn-pill"
              @input="onSearch"></b-form-input>
          </div>
        </div>
      </div>
      <div class="d-flex justify-content-end w-100 mr-3">

        <div v-if="isSearch2" class='col-5 p-0 d-flex'>
          <div class="mr-0 d-flex" style="width: 50%; position: relative; left: 6vw">
            <div style="position: relative; top: 1em; left: 2.5em">
              <feather style="width: 15px" type="search" />
            </div>
            <b-form-input style="width: 100% !important; padding: 0 0em 0 2em; height: 75%" type="text"
              placeholder="Search" v-model="search" @input="onSearch" />
          </div>
          <div style="width: 50%">
            <show-pagination :perPage="params['limit']" @update="onPerPageChange"></show-pagination>
          </div>
        </div>

        <div v-if="isSearch3" class='d-flex justify-content-end w-25 mb-1'>
          <div class="mr-0 d-flex" style="width: 80%; height: 40px">
            <div style="position: relative; top: 1em; left: 2.5em">
              <feather style="width: 15px" type="search" />
            </div>
            <b-form-input style="width: 100% !important;  padding: 0 0em 0 2em; height: 100%" type="text"
              placeholder="Search" v-model="search" @input="onSearch" />
          </div>
        </div>

        <div v-if="isPagination" class="col-3 p-0">
          <show-pagination :perPage="params['limit']" @update="onPerPageChange"></show-pagination>
        </div>

        <div class="col-auto p-0 ml-2" v-if="isSetting">
          <header-setting v-bind:data="{ columns: data.columns, headTopic: data.headTopic }"></header-setting>
        </div>
        <div class="col-auto p-0 ml-2" v-if="isFilter">
          <filterSettingVue ref="refFilterSetting" :custom="data.filter_custom" :col="data.filter_col"
            :field="data.columns" :module="data.module" @update="onFilter"></filterSettingVue>
        </div>
        <div class="col-auto p-0 ml-2" v-if="isImport">
          <b-button v-b-modal="'modal-import'" @click="setImportDefault" class="border m-0" variant="info">
            <i class="icofont icofont-download-alt"></i> Import
          </b-button>
          <importSetting ref="importSettingComponent" v-bind:data="{
            importField: data.importDetail.importField,
            importUrl: data.importDetail.importUrl,
            module: data.module,
          }" @reload="onSearch"></importSetting>
        </div>
        <div class="col-auto p-0 ml-2" v-if="isExport">
          <b-button class="border m-0" variant="secondary" @click="onExport">
            <i class="icofont icofont-upload-alt"></i> Export
          </b-button>
          <exportSetting v-bind:data="{
            exportFileName: data.exportDetail.fileName,
            exportUrl: data.exportDetail.exportUrl,
            module: data.module,
          }" ref="exportComponent"></exportSetting>
        </div>
      </div>
    </div>
    <div v-if="renderMode == 'ssr' ||
      renderMode == undefined ||
      renderMode == '' ||
      renderMode == null
    ">
      <vue-good-table styleClass="vgt-table" mode="remote" :isLoading.sync="isLoading" @on-row-click="onRowClick"
        :totalRows="totalRecords" :columns="data.columns" :rows="data.rows" :fixed-header="true"
        @on-page-change="onPageChange" @on-sort-change="onSortChange" @on-per-page-change="onPerPageChange"
        :expandedOptions="{
          key: 'id',
          expandedRows,
        }" :pagination-options="{
          enabled: true,
          mode: 'pages',
          dropdownAllowAll: false,
          perPage: params['limit'],
          setCurrentPage: params['page'],
        }">
        <template slot="table-row" slot-scope="props">
          <customRowTemplateVue @on-row-click="onRowClick" @eval="eval" @active="active" :props="props"
            @clicked="clicked" @modal="openModal" @deleteRow="deleteRow" @resend="resend" @status="status"
            @editRow="editRow" @moveRow="moveRow" />
        </template>
        <template slot="expanded-row" slot-scope="props">
          <div class="row">
            <div class="col-4">
              <div class="card" style="height: 22rem; overflow-y: scroll">
                <div class="card-header h5 p-3" style="background-color: #d9e2ff">
                  Call Info
                </div>

                <div class="card-body p-1 py-3" style="overflow-y: scroll">
                  <table>
                    <tr>
                      <th>Name</th>
                      <th>Source</th>
                      <th>Start Time</th>
                      <th>End Time</th>
                    </tr>
                    <tr>
                      <td>
                        <p>{{ props.row.name }}</p>
                      </td>
                      <td>
                        <p>{{ props.row.source }}</p>
                      </td>
                      <td>
                        <p>{{ props.row.duration }}</p>
                      </td>
                      <td>
                        <p>{{ props.row.duration }}</p>
                      </td>
                    </tr>
                  </table>
                </div>
              </div>
            </div>
            <div class="col-4">
              <div class="card" style="height: 22rem; overflow-y: scroll">
                <div class="card-header h5 p-3" style="background-color: #d9e2ff">
                  Evaluation
                </div>

                <div class="card-body p-1 py-3" style="overflow-y: scroll">
                  <table>
                    <tr>
                      <th>Date</th>
                      <th>Evaluator</th>
                      <th>Evaluation Form</th>
                      <th>QM Score</th>
                    </tr>
                    <tr>
                      <td>
                        <p>{{ props.row.date | moment('LLL') }}</p>
                      </td>
                      <td>
                        <p>{{ props.row.evaluator_name }}</p>
                      </td>
                      <td>
                        <p>Service</p>
                      </td>
                      <td>
                        <p>75.33</p>
                      </td>
                    </tr>
                  </table>
                </div>
              </div>
            </div>
            <div class="col-4">
              <div class="card" style="height: 22rem; overflow-y: scroll">
                <div class="card-header h5 p-3" style="background-color: #d9e2ff">
                  Note
                </div>

                <div class="card-body p-3">
                  <div class="row">
                    <div class="col-12">
                      <b-list-group tag="ul" flush style="height: 8rem; overflow-y: scroll">
                        <b-list-group-item v-for="n in 3" :key="n" tag="li">
                          <span> {{ new Date() | moment('LLL') }}</span>
                          <span class="border-left border-right mx-2 px-2">
                            {{ props.row.name }}</span>
                          <span> comment</span>
                        </b-list-group-item>
                      </b-list-group>
                    </div>
                    <div class="col-12 my-3">
                      <b-form-textarea placeholder="Comment" v-model="comment" rows="2" max-rows="6"></b-form-textarea>
                    </div>
                    <div class="col-12 d-flex justify-content-end">
                      <b-button @click="saveComment" variant="primary" class="btn-pill">Save</b-button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </template>

        <template slot="pagination-bottom" slot-scope="props">
          <custom-pagination :limit="params['limit']" :total="props.total" :pageChanged="props.pageChanged">
          </custom-pagination>
        </template>
      </vue-good-table>
    </div>
    <div v-else-if="renderMode == 'csr'">
      <vue-good-table ref="someTable1" @on-selected-rows-change="itemSelect" styleClass="vgt-table striped"
        style="width: 100%" :fixed-header="true" :columns="data.columns" :rows="data.rows" :select-options="{
          enabled: isShowSelect,
          selectOnCheckboxOnly: true,
          disableSelectInfo: true,
          selectAllByGroup: true,
        }" :search-options="{
          enabled: true,
          externalQuery: search,
        }" :expandedOptions="{
          key: 'id',
          expandedRows,
        }" :pagination-options="{
          enabled: true,
          perPage: params['limit'],
        }">
        <template slot="table-row" slot-scope="props">
          <customRow :props="props" :custom="data.rowCustom" :isShowSelect="isShowSelect" @deleteRow="deleteRow"
            @editRow="editRow" @moveRow="moveRow" @editToggle="editToggle" @closeRow="closeRow" />
        </template>
        <template slot="pagination-bottom" slot-scope="props">
          <div :class="data.msg ? 'd-flex justify-content-between' : ''">
            <p style="color: #f73164; font-size: 12px; margin-top: 5px">{{ data.msg ? data.msg : '' }} </p>
            <custom-pagination v-if="isPagination" :limit="params['limit']" :total="props.total"
              :pageChanged="props.pageChanged">
            </custom-pagination>
          </div>
        </template>
      </vue-good-table>
    </div>
  </div>
</template>
<style>
/* .vgt-wrap {
    padding-top: 3rem;
  } */

.vgt-fixed-header {
  width: -webkit-fill-available;
}

.vgt-inner-wrap {
  -webkit-box-shadow: 0 !important;
  box-shadow: none;
}

.vgt-responsive {
  max-height: 30rem;
  overflow-y: scroll;
  overflow-x: inherit !important;
}

th {
  border-bottom: 1px solid #dcdfe6;
}

.btn-grey:hover {
  background: rgb(235, 235, 235) !important;
}

.dropdown-toggle-no-caret {
  transform: rotate(90deg) !important;
}

table.vgt-table td {
  vertical-align: middle !important;
  /* max-width: 15rem; */
  min-width: 6.5rem;

  word-break: break-all;
}

button#__BVID__46__BV_toggle_ {
  /* padding: 0 !important; */
  margin-left: 0.5rem !important;
  padding: 0.4rem 1rem !important;
}

i.search-icon {
  top: 0.5rem !important;
}

.vgt-table thead th {
  background: white !important;
}

.b-dropdown-form {
  display: inline-block;
  padding: 0px 0px 0px 1.5rem !important;
  width: 100%;
  clear: both;
  font-weight: 400;
}

.-col-group-container {
  border-bottom: 1px solid #ddd;
}
</style>
<script>
import Vue from 'vue';
import exportSetting from './export-setting.vue';
import HeaderSetting from './header-setting.vue';
import CustomPagination from './custom-pagination.vue';
import ShowPagination from './show-pagination.vue';
import VueGoodTablePlugin from 'vue-good-table';
import customRowTemplateVue from './custom-row-template.vue';
import filterSettingVue from './filter-setting.vue';
import importSetting from './import-setting.vue';
import 'vue-good-table/dist/vue-good-table.css';
import customRow from './custom-row.vue';
Vue.use(VueGoodTablePlugin);
export default {
  name: 'DataTable', // `name` is required as a recursive component
  components: {
    exportSetting,
    HeaderSetting,
    CustomPagination,
    ShowPagination,
    customRowTemplateVue,
    filterSettingVue,
    importSetting,
    customRow,
  },
  props: {
    data: Object,
    isSetting: Boolean,
    isSearch: Boolean,
    isSearch2: Boolean,
    isSearch3: Boolean,
    isPagination: Boolean,
    isFilter: Boolean,
    isShowSelect: Boolean,
    isImport: Boolean,
    isExport: Boolean,
    url: String,
    renderMode: String,
  },
  data() {
    return {
      expandedRows: [],
      // rows:[],
      comment: '',
      search: '',
      filter: {},
      sortField: '',
      isLoading: false,
      params: {
        sortType: '',
        page: 1,
        limit: 50,
      },
      totalRecords: 0,
      json_data: [],
      filename: 'exportfile',
    };
  },
  async mounted() { },
  methods: {
    itemSelect(v) {
      // console.log('itemSelect: ', v)
      this.$emit('itemSelect', v);
    },
    setImportDefault() {
      this.$refs.importSettingComponent.setDefault();
    },
    resend(v) {
      this.$emit('resend', v);
    },
    status(v, e) {
      this.$emit('status', v, e);
    },
    openModal(v, id) {
      this.$emit('openModal', v, id);
    },
    editToggle(v) {
      this.$emit('editToggle', v);
    },
    deleteRow(v) {
      this.$emit('deleteRow', v);
    },
    moveRow(v) {
      this.$emit('moveRow', v);
    },
    editRow(v) {
      this.$emit('editRow', v);
    },
    closeRow(v) {
      this.$emit('closeRow', v);
    },
    saveComment() {
      alert(this.comment);
    },
    clicked(clickedId) {
      if (this.expandedRows.some((id) => id == clickedId)) {
        this.expandedRows = this.expandedRows.filter((v) => v !== clickedId);
      } else {
        this.expandedRows.splice(0, 1, clickedId);
      }
    },
    active(value) {
      this.$emit('setActive', value);
    },
    onRowClick(params) {
      this.$emit('dataRow', params);
    },
    eval(params) {
      this.$emit('eval', params);
    },
    exportData(type) {
      switch (type) {
        case 'xlsx':
          this.$refs.exportComponent.exportXlsxData();
          break;
        case 'csv':
          this.$refs.exportComponent.exportCsvData();
          break;
      }
    },
    setTotalRecords(total) {
      this.totalRecords = total;
    },
    setPages(pages) {
      this.params['page'] = pages;
    },
    setLimit(limit) {
      this.params['limit'] = limit;
    },
    setCurrentPerPage(perPage) {
      this.$refs['someTable1'].currentPerPage = perPage;
    },
    setIsLoading(isLoad) {
      this.isLoading = isLoad;
    },
    async loadItems() {
      this.isLoading = true;
      var object = {};
      object['filter'] = this.filter;
      object['search'] = this.search;
      object['sortField'] = this.sortField;
      object['params'] = this.params;
      object['totalRecords'] = this.totalRecords;
      this.$emit('load', object);
    },
    async loadItemsOnfilter() {
      this.isLoading = true;
      var object = {};
      object['filter'] = this.filter;
      object['search'] = this.search;
      object['sortField'] = this.sortField;
      object['params'] = this.params;
      object['params'].page = 1;
      object['totalRecords'] = this.totalRecords;
      this.$emit('load', object);
    },
    convertTimeIsotoDateTime(isotime) {
      var date = new Date(isotime);
      var year = date.getFullYear();
      var month = date.getMonth() + 1;
      var dt = date.getDate();
      var hh = date.getHours();
      var mm = date.getMinutes();
      var ss = date.getSeconds();
      if (dt < 10) {
        dt = '0' + dt;
      }
      if (month < 10) {
        month = '0' + month;
      }
      if (ss < 10) {
        ss = '0' + ss;
      }
      return year + '-' + month + '-' + dt + ' ' + hh + ':' + mm + ':' + ss;
    },
    async onSearch() {
      await this.loadItems();
    },
    setFilter(params) {
      this.filter = params;
    },
    async onFilter(params) {
      this.filter = params;
      // console.log('onFilter', this.filter);
      await this.loadItemsOnfilter();
    },
    async onExport() {
      this.$refs.exportComponent.exportItem();
    },
    async onPageChange(params) {
      this.params['page'] = params.currentPage;
      await this.loadItems();
    },
    async onPerPageChange(params) {
      this.params['page'] = 1;
      this.params['limit'] = params.currentPerPage;
      await this.loadItems();
    },
    async onSortChange(params) {
      this.sortField = params[0].field;
      this.params['sortType'] = params[0].type;
      await this.loadItems();
    },
  },
};
</script>
